document.addEventListener('DOMContentLoaded', function() {
    if (typeof Swiper !== 'undefined') {
        const relatedProductsSwiper = new Swiper('.related-products-swiper', {
            loop: true,
            slidesPerView: 1,
            spaceBetween: 0,
            grabCursor: true,
            navigation: {
                nextEl: '.related-products-next',
                prevEl: '.related-products-prev',
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                },
                1024: {
                    slidesPerView: 4,
                },
            },
        });
    }
});